import { defineStore } from "pinia";
import RepositoryFactory from "@/repositories/apiGateWay/repositoryFactory";
const apiGatewayRepository = RepositoryFactory.get('apiGateway');
import ApplicationError from "@/helpers/applicationError";
import { API_RESPONSE_SUCCESS, HTTP_CODE_SUCCESS } from "@/data/constants";

export const useNewsStore = defineStore('newsPage', {
    state: () => ({
        isLoading: false,
        page: 1,
        totalPages: null,
        newsList: [],
    }),
    getters: {

    },
    actions: {
        async getNews(page) {
            this.isLoading = true;
            try {
                const newsList = await apiGatewayRepository.getNews({
                    "limit": process.env.VUE_APP_PAGINATION_LIMIT,
                    "offset": page != null ? (page-1) * process.env.VUE_APP_PAGINATION_LIMIT : 0
                });

                if (newsList.success == API_RESPONSE_SUCCESS && newsList.code == HTTP_CODE_SUCCESS) {
                    this.newsList = newsList.data;
                    this.totalPages = newsList.meta.total != null && newsList.meta.limit != null ? Math.ceil(newsList.meta.total / newsList.meta.limit) : 1;
                }
                this.isLoading = false;
            } catch (e) {
                this.isLoading = false;
                throw new ApplicationError(e.message, {}, e)
            }
            this.isLoading = false;
        },
    }
});